import bridge from '../core';

const apiName = 'setTitle';

function fallback(title) {
    document.title = title;
}

function back(params) {
    return {
        api: params,
        fallback
    };
}

bridge.register(apiName, back);
